module.exports = __webpack_public_path__ + "678b861f2e8bf913282c6990b4805a67.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-semibold-italic.ttf
// module id = 91
// module chunks = 0